var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"category",attrs:{"href":_vm.link}},[_c('span',{staticClass:"category__icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('span',{staticClass:"category__text"},[_vm._v(_vm._s(_vm.category.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }